/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';

export const useHasScroll = <T extends HTMLElement = any>(
	deps: any[] = [],
): {
	ref: React.RefObject<T>;
	isHas: boolean;
} => {
	const [isHas, setIsHas] = useState(false);

	const ref = useRef<T>(null);

	useEffect(() => {
		const el = ref.current;

		if (!el) return;

		const checkScroll = () => {
			setIsHas(el.scrollHeight > el.clientHeight);
		};

		const observer = new ResizeObserver(checkScroll);

		checkScroll();

		observer.observe(el);

		// eslint-disable-next-line consistent-return
		return () => observer.disconnect();
	}, [...deps]);

	return { ref, isHas };
};
